import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import "./styles/TestCard.css";

const TestCard = ({ link, token }) => {
  const [test, setTest] = useState(null);
  const [error, setError] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hasAttemptedLoad, setHasAttemptedLoad] = useState(false);
  const testId = link.split("/test/")[1];

  useEffect(() => {
    if (hasAttemptedLoad) return;

    const fetchTest = async () => {
      try {
        const res = await axios.get(
          `https://tests-lp-server-3c9781d8081f.herokuapp.com/api/tests/${testId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );

        if (res.data.error) {
          setError(res.data.error);
          setTest(res.data.test);
        } else {
          setTest(res.data);
        }
      } catch (err) {
        const code = err.response?.data?.code;
        const error = err.response?.data?.error;
        const partialTest = err.response?.data?.test;

        if (
          code === "TEST_UNPUBLISHED" ||
          code === "TEST_EXPIRED" ||
          code === "TEST_ALREADY_PASSED" ||
          code === "NOT_AUTHENTICATED"
        ) {
          setError(error);
          setTest(partialTest); // Частичные данные
        } else {
          console.error("Ошибка загрузки теста:", err);
          setError("Ошибка загрузки теста");
        }
      } finally {
        setLoading(false);
        setHasAttemptedLoad(true);
      }
    };

    fetchTest();
  }, [testId, token, hasAttemptedLoad]);

  if (hidden) return null;

  if (loading)
    return <div className="test-card loading">Загрузка теста...</div>;

  //if (error) {
  //  return (
  //    <div className="test-card-error">{error && <p>{error.message}</p>}</div>
  //  );
  //}

  return (
    <motion.div
      className="test-card"
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: "spring", bounce: 0.3 }}
    >
      <div className="test-card-left">
        <h4>{test.title}</h4>
        <p>{test.description || "Описание отсутствует"}</p>
        <small>Автор: {test.author?.username}</small>
      </div>
      <div className="test-card-right">
        <div className="test-card-meta">
          {error && <span className="badge error">{error.message}</span>}
          {test.timeLimit && (
            <span className="badge">⏱ {test.timeLimit} мин</span>
          )}
          {test.expiresAt && (
            <span className="badge">
              📅 до {new Date(test.expiresAt).toLocaleDateString()}
            </span>
          )}
        </div>
        <a
          className="test-card-button"
          href={`https://tests.learningportal.ru/test/${test._id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Пройти тест
        </a>
      </div>
    </motion.div>
  );
};

export default TestCard;
